/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2024
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { IAny } from '../../components/DashboardKPIWidgets/IEnergyManagementProps';
import { IIndepVarFormData } from './BaselineConfigContext';

class BaselineConfigActions {
  static UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
  static INITIALIZE_FORM_DATA = 'INITIALIZE_FORM_DATA';
  static RESET_FORM_DATA = 'RESET_FORM_DATA';

  static updateFormData = (payload: {
    key: string;
    value: Partial<IIndepVarFormData>;
  }) => {
    return {
      type: BaselineConfigActions.UPDATE_FORM_DATA,
      payload
    };
  };

  static initializeFormData = (formData: {
    [key: string]: IIndepVarFormData;
  }) => {
    return {
      type: BaselineConfigActions.INITIALIZE_FORM_DATA,
      payload: formData
    };
  };

  static resetFormData = () => {
    return {
      type: BaselineConfigActions.RESET_FORM_DATA
    };
  };
}

export default BaselineConfigActions;
